import { ToolCallData } from "../stores";

import { firstString, unwrapToolOutputRecord } from "./toolOutputParsing";
import { resolveEntityTypeFromToolType } from "./toolVisual";

import { EntityType } from "@/queries/folder-entities/types";

export interface EntityPreview {
  entityType: string;
  entityId: string;
  typeLabel: string;
  title: string;
  subtitle?: string;
  description?: string;
  url?: string;
}

export const parseEntityPreview = (toolCall: ToolCallData): EntityPreview | null => {
  const output = unwrapToolOutputRecord(toolCall.output);
  if (!output) {
    return null;
  }

  const previewRecord =
    output.entity_preview && typeof output.entity_preview === "object"
      ? (output.entity_preview as Record<string, unknown>)
      : null;
  if (!previewRecord) {
    return null;
  }

  const title = firstString(previewRecord.title);
  if (!title) {
    return null;
  }

  const entityType = firstString(previewRecord.entity_type) ?? "UNKNOWN";
  const entityId = firstString(previewRecord.entity_id) ?? "";
  const typeLabel = firstString(previewRecord.type_label) ?? "Entity";
  const subtitle = firstString(previewRecord.subtitle);
  const description = firstString(previewRecord.description);
  const previewUrl = firstString(previewRecord.url);
  const navigationUrl = firstString(toolCall.navigation?.[0]?.url);

  return {
    entityType,
    entityId,
    typeLabel,
    title,
    subtitle,
    description,
    url: previewUrl ?? navigationUrl,
  };
};

export const entityPreviewIconType = (preview: EntityPreview): EntityType | null =>
  resolveEntityTypeFromToolType(preview.entityType);
